/*
* ぽちボタンクリック後の処理
*/ 

class afrPostVideoProduction {
  constructor(that) {
    this.that = that
    this.formName = "動画制作"
    this.that.$('.search_form_wrap').show()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store

    store.commit('setValue', ['video_production', 'input_video_production_val', $('input[name="video_production"]:checked').val(), 'video_production'])
    // store.commit('setValue', ['video_production', 'inputServiceContentItem1', $('#service_content_item1_video_production').val(), ''])
    // store.commit('setValue', ['video_production', 'inputServiceContentItem1Price', $('#service_content_item1_price_video_production').val(), ''])
  }

  setVal (balanceInfoMsg) {
    const store = this.that.store

    const sendVal = 
`
◎動画制作
プラン：${store.state.formData.video_production.input_video_production_val}
`
// サービス内容内訳項目1：${store.state.formData.video_production.inputServiceContentItem1}
// サービス内容金額1：${store.state.formData.video_production.inputServiceContentItem1Price}円

    store.commit('setTalknoteMessage', ['video_production', sendVal])
  } 
}

export default {
  afrPostVideoProduction
}